import WorkInGolfHero from './work-in-golf-hero'

export default WorkInGolfHero
